export default "__VITE_ASSET__0e8f5318__"